import useSubmitButtonName from 'hooks/forms/useSubmitButtonName';
import useSubmit from 'hooks/forms/useSubmitForm';
import { message } from 'antd';
import I18n from 'i18n-js';
import buildFormParams from '../helpers/buildFormParams';

const useSubmitForm = ({
  form,
  formUrl,
  clearErrors,
  handleError,
  setComments,
  attachments = [],
  setAttachments = (_files) => {},
}) => {
  const { handleSubmitForm, isFormSending } = useSubmit({
    formUrl,
    handleError,
    objectId: null,
    beforeSubmitForm: clearErrors,
    buildFormParams: () => (buildFormParams({ form, attachments })),
    afterSuccessSubmitForm: ({ data }) => {
      form.resetFields();
      setAttachments([]);
      setComments((prev) => [...prev, data.comment]);
      message.success(I18n.t('flash.ticket_comments.created'));
    },
  });

  const handleSubmitWrapper = (formData) => {
    clearErrors();
    handleSubmitForm(formData);
  };

  const submitButtonName = useSubmitButtonName({
    objectId: null,
    isFormSending,
    modelName: 'ticket_comment',
  });

  return {
    isFormSending,
    submitButtonName,
    handleSubmitForm: handleSubmitWrapper,
  };
};

export default useSubmitForm;
